import create, { SetState, GetState } from 'zustand';

const stateDefault = {
  dataSetting: null,
  result: {},
  selected: null,
  page: 1,
  keywords: '',
};

const actions = (set, get) => ({
  setResult: (payload) => {
    set((state) => ({
      ...state,
      result: payload,
    }));
  },
  setSelected: (payload) => {
    set((state) => ({
      ...state,
      selected: payload,
    }));
  },
  setDataSettings: (payload) => {
    set((state) => ({
      ...state,
      dataSetting: payload,
    }));
  },
  setPage: (payload) => {
    set((state) => ({
      ...state,
      page: payload,
    }));
  },

  setKeywords: (payload) => {
    set((state) => ({
      ...state,
      keywords: payload,
    }));
  },
});

export const useDataSettings = create((set, get) => ({
  ...stateDefault,
  ...actions(set, get),
}));
